module.exports = __webpack_public_path__ + "static/img/nibdlogo.31e06bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nibdlogo.png
// module id = UgLR
// module chunks = 87